var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wheel-slide",class:{active: _vm.active},on:{"click":_vm.onClick}},[_c('div',{staticClass:"image",style:({backgroundImage: 'url("' + _vm.data.url + '")'}),attrs:{"ga-category":"slider","ga-label":"wheelsSlide"}})])}
var staticRenderFns = []

export { render, staticRenderFns }